import { FC, useCallback, useMemo } from 'react';
import { Button, Card, RadixTable, TColumn } from '@features/ui';
import { ProductOffer } from '@src/types/productsAddons.ts';
import { TradingPlatForms } from '@src/types';

interface ProductResetProps {
  onEdit: (id: number) => void;
  data: ProductOffer[];
}
export const ProductReset: FC<ProductResetProps> = ({ onEdit, data }) => {
  const handleEdit = useCallback(
    (id?: number) => {
      if (!id) return;
      onEdit(id);
    },
    [onEdit]
  );

  const columns = useMemo(
    (): TColumn<ProductOffer>[] => [
      {
        title: '#',
        className: 'w-10',
        render: (_, index) => <p>{(index ?? 0) + 1}</p>,
      },
      {
        title: 'Title',
        render: (item) => <p>{item?.title}</p>,
      },
      {
        title: '',
        render: (item) => {
          const compatibleDataFeeds = item?.compatible_data_feeds ?? [];

          return (
            <div
              className={'flex gap-x-5 w-full'}
              style={{ width: compatibleDataFeeds.length * 121 }}
            >
              {compatibleDataFeeds.map((itemDataFeed) => {
                if (itemDataFeed === TradingPlatForms.CQG_DATA_FEED) {
                  return (
                    <img
                      key={itemDataFeed}
                      alt="leeloo-logo"
                      className={'w-[101px] h-[30px]'}
                      src="/assets/logo-tradovate.png"
                    />
                  );
                }
                if (itemDataFeed === TradingPlatForms.RITHMIC_DATA_FEED) {
                  return (
                    <img
                      key={itemDataFeed}
                      alt="leeloo-logo"
                      className={'w-[101px] h-[30px]'}
                      src="/assets/logo-rithmic.png"
                    />
                  );
                }

                return (
                  <img
                    key={itemDataFeed}
                    alt="leeloo-logo"
                    className={'w-[101px] h-[30px]'}
                    src="/assets/logo-dxfeed.png"
                  />
                );
              })}
            </div>
          );
        },
      },
      {
        title: 'Visible on website',
        render: (item) => <p>{item?.is_visible_on_web ? 'Yes' : 'No'}</p>,
      },
      {
        title: '',
        render: (item) => (
          <Button
            size={'sm'}
            variant={'secondary'}
            onClick={() => handleEdit(item?.id)}
          >
            Edit
          </Button>
        ),
      },
    ],
    [handleEdit]
  );

  return (
    <Card className={'mt-[27px] pl-[18px] pr-[24px]'}>
      <RadixTable columns={columns} data={data} />
    </Card>
  );
};
